import { Directive, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, ValidatorFn } from '@angular/forms';

export function controlValueIsGreaterThanTargetValidator(targetValue: number, errorMessage: string): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const controlValue = +control.value;
    const error = {} as { [key: string]: any };
    error[errorMessage] = targetValue;
    return controlValue <= targetValue ? error : null;
  };
}

@Directive({
  selector: '[appFieldValueGreaterThan]',
  standalone: true,
  providers: [{ provide: NG_VALIDATORS, useExisting: FieldValueGreaterThanDirective, multi: true }],
})
export class FieldValueGreaterThanDirective {
  @Input()
  targetField: HTMLInputElement;

  @Input()
  errorMessage = 'commons.validations.min';

  validate(control: AbstractControl): ValidationErrors | null {
    const targetValue = +this.targetField?.value;
    return control.value && targetValue ? controlValueIsGreaterThanTargetValidator(targetValue, this.errorMessage)(control) : null;
  }
}
